export default "__VITE_ASSET__BDABVuQE__"